export default class Repository {
    dataSource;

    constructor(dataSource) {
        this.dataSource = dataSource;
    }

    filterNull(source) {
        for (let key in source) {
            if (source.hasOwnProperty(key)) {
                if ((typeof source[key] === 'object' && !source[key]) || typeof source[key] === 'undefined') {
                    delete source[key];
                } else if (typeof source[key] === 'object') {
                    source[key] = this.filterNull(source[key])
                }
            }
        }

        return source;
    }
}
